import { TOptions } from 'i18next'
import React from 'react'

import Text from '@/components/elements/atoms/Text/Text'

import STYLES from './WizardQuestionTitle.module.sass'

type Props = {
  namespace?: string
  title: string
  subtitle?: string
  variables?: TOptions
}

const WizardQuestionTitle = ({
  namespace,
  title,
  subtitle,
  variables
}: Props): JSX.Element | null => {
  return (
    <div className={STYLES.wrapper}>
      <div data-testid="hero-text-title" className={STYLES.title}>
        <Text
          text={title}
          namespace={namespace}
          variant="textRegular20"
          element="h1"
          margin={false}
          variables={variables}
          bold
        />
      </div>
      {subtitle && (
        <div className={STYLES.subtitle}>
          <Text
            text={subtitle}
            namespace={namespace}
            variant="textRegular14"
            element="p"
            margin={false}
          />
        </div>
      )}
    </div>
  )
}

export { Props }
export default WizardQuestionTitle
